<script>
import Icon from "@/components/atoms/icon";
import Badge from "@/components/atoms/badge";
import Container from "@/components/atoms/container";
import LazyImage from "@/components/atoms/lazy-image";
import ShippingMethodList from "@/containers/shipping-method/shipping-method-list";
import Popin from "@/components/molecules/popin";
import AlerteConfirmationMagasin from "@/containers/alerte-confirmation-magasin";
import Titre from "@/components/atoms/titre";
import GridRow from "@/components/molecules/grid/grid-row";
import GridCol from "@/components/molecules/grid/grid-col";
import Card from "@/components/molecules/card";
import ContainerHeading from "@/containers/container-heading";
import Divider from "@/components/atoms/divider";
import AbonnementLadBanniereRenouvellement from "@/components/organisms/abonnement-lad/panier/renouvellement/mobile";
import AbonnementLadBanniere from "@/components/organisms/abonnement-lad/panier/non-abonne";
import {
  ABO_LAD_OTHER_COOKIE_NAME,
  useAbonnementLadBanner
} from "@/composables/abonnement-lad";
import { getOneLink } from "@/utils/link-carrefour";

import bandeauLegalVapotageMobile from "@/assets/images/bandeau-legal-vapotage-mobile.jpg";
import bandeauLegalAlcoolMobile from "@/assets/images/bandeau-legal-alcool-mobile.jpg";
import BandeauBascule from "@/components/organisms/banniere-bascule";

import { pageCommanderEmits, usePageCommander } from "./mixin";

export default {
  components: {
    Icon,
    Badge,
    Container,
    LazyImage,
    ShippingMethodList,
    Popin,
    AlerteConfirmationMagasin,
    Titre,
    Card,
    GridCol,
    GridRow,
    ContainerHeading,
    Divider,
    AbonnementLadBanniereRenouvellement,
    AbonnementLadBanniere,
    BandeauBascule
  },
  emits: [...pageCommanderEmits()],
  setup(props, context) {
    const popinAlerteMagasin = ref(null);
    const { isClosedLad, closeLadBanner } = useAbonnementLadBanner(
      ABO_LAD_OTHER_COOKIE_NAME
    );
    const {
      magasin,
      isChangeMagasinLoading,
      magasinName,
      shippingMode,
      isPremiereCommande,
      isMagasinInhabituel,
      warning,
      typePanier,
      showAbonnementLadBanniere,
      showAbonnementLadBanniereRenouvellement,
      hidePopinAlerteMagasin,
      changeMagasin,
      alerteConfirmationHidden,
      setRedirect,
      isDispoCarrefour,
      jourDispoPremierCreneauCarrefour
    } = usePageCommander(context, popinAlerteMagasin);

    return {
      magasin,
      isClosedLad,
      closeLadBanner,
      isChangeMagasinLoading,
      magasinName,
      shippingMode,
      isPremiereCommande,
      isMagasinInhabituel,
      warning,
      typePanier,
      showAbonnementLadBanniere,
      showAbonnementLadBanniereRenouvellement,
      hidePopinAlerteMagasin,
      changeMagasin,
      alerteConfirmationHidden,
      setRedirect,
      bandeauLegalVapotageMobile,
      bandeauLegalAlcoolMobile,
      popinAlerteMagasin,
      isDispoCarrefour,
      jourDispoPremierCreneauCarrefour
    };
  }
};
</script>

<template>
  <div
    id="content"
    role="main"
  >
    <div class="c-checkout-mobile">
      <p class="c-checkout-mobile__location u-text-center">
        <Icon
          name="location"
          size="sm"
          class="u-mr-xxs"
        />
        Magasin {{ magasinName }}
      </p>
      <Container>
        <BandeauBascule
          v-if="isDispoCarrefour"
          :jour-dispo="jourDispoPremierCreneauCarrefour"
          :redirection-url="getOneLink(magasin)"
        />
        <AbonnementLadBanniereRenouvellement
          v-if="typePanier === 'drive' && showAbonnementLadBanniereRenouvellement && !isClosedLad"
          class="u-mt-sm"
          @close="closeLadBanner"
        />
        <AbonnementLadBanniere
          v-else-if="typePanier === 'drive' && showAbonnementLadBanniere && !isClosedLad"
          class="u-mt-sm"
          @close="closeLadBanner"
        />
        <div class="c-checkout-mobile__step">
          <h1 class="c-checkout-mobile__step-title c-checkout-mobile__step-title--current u-mb-xs u-font-24">
            <Badge
              class="c-checkout-mobile__step-badge c-checkout-mobile__step-badge--current"
              circle
            >
              1
            </Badge>
            Mode de Livraison
          </h1>
          <p class="u-mb-sm u-font-sm">
            Merci de choisir la manière dont vous souhaitez récupérer votre
            commande
          </p>
          <ShippingMethodList @setRedirect="setRedirect" />
        </div>
      </Container><!-- //END container -->
    </div>
    <!-- //END Checkout -->
    <div class="c-checkout-mobile__bottom">
      <Container>
        <div class="c-checkout-mobile__step u-mt-xs">
          <h1 class="c-checkout-mobile__step-title u-font-24">
            <Badge
              class="c-checkout-mobile__step-badge"
              circle
            >
              2
            </Badge>
            Paiement & avantages
          </h1>
        </div>

        <div class="c-checkout-mobile__step u-mt-xs">
          <h1 class="c-checkout-mobile__step-title u-font-24">
            <Badge
              class="c-checkout-mobile__step-badge"
              circle
            >
              3
            </Badge>
            Confirmation
          </h1>
        </div>
      </Container>
      <ContainerHeading
        icon-name="chaine-du-froid"
        icon-color="primary"
        icon-size="xlg"
        bg-color="bg"
        dotted
        class="u-mt-xlg"
      >
        <Titre
          tag="p"
          size="xs"
          class="u-text-center u-mb-md"
        >
          Nous respectons la chaine du froid<br />
          de la préparation, au retrait ou à la livraison !
        </Titre>
        <div class="u-mx-lg@md u-mb-lg u-mb-md@md">
          <GridRow>
            <GridCol
              md="12"
              class="u-mb-sm@md"
            >
              <Card
                radius="md"
                elevation="md"
                border-color="grey-6"
                class="u-p-md u-full-height u-text-center"
              >
                <Icon
                  name="chaine-du-froid-selection"
                  size="xxxlg"
                  variant="primary"
                />
                <p class="u-font-14">
                  Nos produits Frais Traditionnels sont sélectionnés en magasin
                  le jour de votre retrait
                </p>
              </Card>
            </GridCol>
            <GridCol
              md="12"
              class="u-mb-sm@md"
            >
              <Card
                radius="md"
                elevation="md"
                border-color="grey-6"
                class="u-p-md u-full-height u-text-center"
              >
                <Icon
                  name="chaine-du-froid-cora"
                  size="xxxlg"
                  variant="primary"
                />
                <p class="u-font-14 u-text-center">
                  Dans votre magasin, vos produits sont stockés en chambre froide et les
                  produits surgelés dans des congélateurs.
                </p>
              </Card>
            </GridCol>
            <GridCol md="12">
              <Card
                radius="md"
                elevation="md"
                border-color="grey-6"
                class="u-p-md u-full-height u-text-center"
              >
                <Icon
                  name="chaine-du-froid-retraitcasiers"
                  size="xxxlg"
                  variant="primary"
                />
                <p class="u-font-14 u-text-center">
                  Dans nos points de retrait commerçant & nos casiers, des
                  contenants spécifiques garantissent une fraîcheur optimale
                </p>
              </Card>
            </GridCol>
          </GridRow>
        </div>
        <Divider dotted />
      </ContainerHeading>
    </div>
    <Container class="u-text-center">
      <LazyImage
        :src="bandeauLegalAlcoolMobile"
        alt="Interdiction de vente de boissons alcooliques aux mineurs de moins de 18 ans.
                La preuve de majorité de l'acheteur est exigée au moment de la vente en ligne."
        class="u-mb-md"
        width="344"
        height="234"
      />
      <LazyImage
        :src="bandeauLegalVapotageMobile"
        alt="Interdiction de vente de produits du vapotage aux mineurs de moins de 18 ans.
                La preuve de majorité de l'acheteur est exigée au moment de la vente en ligne."
        class="u-pb-md"
        width="344"
        height="234"
      />
    </Container>
    <Popin
      ref="popinAlerteMagasin"
      :visible="isPremiereCommande || isMagasinInhabituel"
      aria-label="Confirmation du magasin"
      size="md"
      slide-up
      @hidden="alerteConfirmationHidden()"
    >
      <AlerteConfirmationMagasin
        :is-premiere-commande="isPremiereCommande"
        :is-magasin-inhabituel="isMagasinInhabituel"
        :is-loading="isChangeMagasinLoading"
        @confirmeMagasin="hidePopinAlerteMagasin"
        @changeMagasin="changeMagasin"
      />
    </Popin>
  </div>
  <!-- //END Main -->
</template>

<style lang="scss" scoped>
@import "@/assets/styles/components/checkout-mobile.scss";
</style>
